import * as React from 'react';
import { connect } from 'react-redux';
import Sidenav from 'ui/components/Sidenav';
import { action } from 'ui/reducers/root';
import { IRootState } from 'ui/reducers/store';
import * as S from './style';
import AlertService from 'ui/utils/alertService';
import { mixpanelService } from 'ui/utils/mixpanel';
import Splash from 'ui/components/Splash';
import { CLICKS } from 'ui/reducers/root/reducer';
import { showSurvey } from 'patientCommons/helpers/survey';
import { getPatientConfig } from 'ui/utils/engine';
import { removeEmptyKeysFromObject } from 'patientCommons/utils/commons';
import { get } from 'lodash';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { IApps, getApps } from 'ui/utils/appsList';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;
type IProps = IStateProps & IDispatchProps & RouteComponentProps<{ empi: string }> & { visibleApps: string };

class SidebarApp extends React.Component<IProps> {
  public onClickHandler = (app: IApps) => {
    (window as any).dispatchEvent(new CustomEvent('DP360-Sidebar-Close'));
    if (app.name === 'summary') {
      const metaData = removeEmptyKeysFromObject({
        patient_id: this.props.match.params.empi,
        care_protocol_name: this.props.careProtocolName,
      });
      mixpanelService.track(`P360: DP360 - ${app.displayName} app closed`, {
        ...metaData,
      });
    } else {
      mixpanelService.track(`${app.displayName} app closed`, {
        category: `D P360  - ${app.displayName}`,
      });
    }
  };

  public render() {
    const { visibleApps } = this.props;
    const appList = getApps(visibleApps);
    return (
      <S.SelectedAppWrapper isDP360Collapsed={this.props.isDP360Collapsed}>
        <Sidenav visibleApps={visibleApps} />
        <S.OverflowContent show={!this.props.isDP360Collapsed} id="overflow-content">
          {appList.map(App => {
            return (
              <S.AppContainer key={`App-${App.name}`} show={App.name === this.props.currentApp}>
                <React.Suspense fallback={<Splash />}>
                  <App.component
                    isDP360Collapsed={this.props.isDP360Collapsed}
                    onClick={() => this.onClickHandler(App)}
                    details={App}
                  />
                </React.Suspense>
              </S.AppContainer>
            );
          })}
          <S.PopupContainer id="sidebar-popup-container" />
        </S.OverflowContent>
        <AlertService clearAll={true} />
      </S.SelectedAppWrapper>
    );
  }

  private handleDP360SidebarClose = (_: Event) => {
    this.props.setSidebarState({
      set: 'close',
    });
  };

  public componentDidMount() {
    window.addEventListener('DP360-Sidebar-Close', this.handleDP360SidebarClose);
  }

  public componentDidUpdate() {
    const SHOW_SURVEY_ON_AFTER_CLICKS = getPatientConfig('patient.DP360.showSurveyOnAfterClicks', 5);
    if (this.props.appsClickCount >= SHOW_SURVEY_ON_AFTER_CLICKS) {
      showSurvey();
    }
  }

  public componentWillUnmount() {
    // reset store for dp360, reset first to ensure valid
    // initial values for currentApp and isDP360Collapsed
    this.props.resetSidebar();

    // set current app to null
    this.props.setCurrentApp({ appName: '' });

    // set dp360 to close
    (window as any).dispatchEvent(new CustomEvent('DP360-Sidebar-Close'));

    // remove event listener
    window.removeEventListener('DP360-Sidebar-Close', this.handleDP360SidebarClose);
  }
}

const mapStateToProps = (state: IRootState) => ({
  currentApp: state.sidebar.root.currentApp,
  isDP360Collapsed: state.sidebar.root.isDP360Collapsed,
  clinicalMeta: state.sidebar.clinical.meta,
  appsClickCount: state.sidebar.root[CLICKS],
  careProtocolName: get(state, 'care.careProtocol.details.data.name', ''),
});

const mapDispatchToProps = {
  setCurrentApp: action.setCurrentApp,
  setSidebarState: action.setSidebarState,
  resetSidebar: action.resetSidebar,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SidebarApp));
